module.exports = __webpack_public_path__ + "img/frame (5).1b42ae4c.jpg";